// Provider-path adapter over the session api fn. The call signature is frozen:
// the capture port calls `uploadBackup(backup, format, undefined, signal)`.
//
// `deserializeBlob` stays here because it is capture's and `@heidi/session` has
// no edge to capture — the package takes a plain `Blob`.
import { type BackupToUpload, type Format } from '@heidi/capture/contracts';
import { uploadBackupAudio } from '@heidi/session/data';
import { deserializeBlob } from '../audio/utils';

export const uploadBackup = async (
  backup: BackupToUpload,
  format: Format,
  onUploadProgress?: (fraction: number) => void,
  signal?: AbortSignal
) => {
  await uploadBackupAudio({
    sessionId: backup.sessionId,
    file: deserializeBlob(backup.blob)!,
    extension: format,
    startTime: backup.startDate.getTime(),
    endTime: backup.endDate.getTime(),
    onUploadProgress,
    signal,
  });
};
